import { AbsolutePoint } from '@app/features/apply-react-signing/components/FieldRenderer/types';

/**
 * (Juyeong-Byeon)
 * 초기화시 입력받은 point와 절대값이 THRESHOLD를 넘어가는지 체크해준다.
 * 일반적으로 drag와 click을 동시에 다루는데, 입력 동작이 click인경우
 * drag시작시에 click을 하지 못하도록 처리하고, drag stop에서 click을 할 수 있도록 disable을 해제해준다.
 * 하지만 drag이벤트는 click을 할때도 일어나서 click을 할 수 없는 상황이 생긴다. 때문에 아래 체크를 통해 drag와 click을 구별해줄 수 있도록 적용.
 *
 * 추후 hook으로 빠질 로직이어서 use prefix를 붙임
 */
export class PointDelta {
  private initialPoint: AbsolutePoint | undefined;

  private X_THRESHOLD = 0;

  private Y_THRESHOLD = 0;

  constructor(X_THRESHOLD = 4, Y_THRESHOLD = 4) {
    this.X_THRESHOLD = X_THRESHOLD;
    this.Y_THRESHOLD = Y_THRESHOLD;
  }

  public initializeStartPoint(initialPoint: AbsolutePoint) {
    this.initialPoint = initialPoint;
  }

  public isExceedThreshold(currentPoint: AbsolutePoint) {
    if (!this.initialPoint) {
      throw new Error(`this.initialPoint is not initialled`);
    }

    const { x: initialX, y: initialY } = this.initialPoint;
    const { x, y } = currentPoint;

    return Math.abs(initialX - x) > this.X_THRESHOLD || Math.abs(initialY - y) > this.Y_THRESHOLD;
  }
}
